<div class="modal-content" style="min-width: 640px;">
  <!-- header fenêtre surgissante -->
  <div class="modal-header">
    <h5 class="modal-title" translate><fa-icon icon="file-alt"></fa-icon> page.suivi.suivi-stocks.estimations-modal.title</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- body fenêtre surgissante -->
  <div class="modal-body">
    <table class="table table-striped" aria-label="Liste des estimations de stock">
      <thead>
        <tr>
          <th translate>page.suivi.suivi-stocks.estimations-modal.espece</th>
          <th translate>page.suivi.suivi-stocks.estimations-modal.groupe-varietal</th>
          <th translate>page.suivi.suivi-stocks.estimations-modal.estimation-stock</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let estimation of estimations; let index = index" [ngClass]="{ 'pointilles': index == indexEspecesDifferentes }">
          <td>
            <fa-icon *ngIf="estimation.espece === 'POMME'" icon="apple-alt" class="color-black"></fa-icon>
            <img *ngIf="estimation.espece === 'POIRE'" class="pear-img" src="/assets/img/pear.png" alt="Poire" />
          </td>
          <td>{{ estimation.groupeVarietal }}</td>
          <td>{{ estimation.stock | saisieRecolteFormat : '0' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
